import { ILeaderboard } from './useLeaderboard';

/* eslint-disable no-unused-vars */
export enum SlideType {
  agent = 'agent',
  queue = 'queue',
  skeleton = 'skeleton',
}
/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */
export enum SlideMetric {
  allcalls = 'allcalls',
  allanswered = 'allanswered',
  allconnections = 'allconnections',
  alldurationavg = 'alldurationavg',
  alldurationsum = 'alldurationsum',
  allincoming = 'allincoming',
  allmissed = 'allmissed',
  alloutgoing = 'alloutgoing',
  incominganswered = 'incominganswered',
  incomingconnection = 'incomingconnection',
  incomingmissed = 'incomingmissed',
  outgoinganswered = 'outgoinganswered',
  outgoingconnection = 'outgoingconnection',
  outgoingmissed = 'outgoingmissed',
  tduration = 'tduration',
  alldurationavgmin = 'alldurationavgmin',
}
/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */
export enum SlidePeriod {
  day = 'day',
  week = 'week',
  month = 'month',
  quarter = 'quarter',
  past14hours = 'past14hours',
  past24hours = 'past24hours',
  last7days = 'last7days',
  last30days = 'last30days',
}
/* eslint-enable no-unused-vars */

export interface SlideBase {
  slideId: string;
  type: SlideType;
  active: boolean;
  slideDurationInSec: number;
  slideName: string;
}

export interface AgentSlide extends SlideBase {
  type: SlideType.agent;
  teamId: string | number;
  showAllUsers: boolean;
  metric: SlideMetric;
  timePeriod: SlidePeriod;
  pages: IPage[];
}

export interface QueueSlide extends SlideBase {
  type: SlideType.queue;
  queueId: string;
  queueid: {
    queueid: number;
    queuename: string;
  };
}

export interface SkeletonSlide extends SlideBase {
  type: SlideType.skeleton;
}

export type Slide = AgentSlide | QueueSlide | SkeletonSlide;

export interface ISlideObservable {
  slide: Slide;
  observers: SlideEventObserver[];
  notify: (event: SlideEvent) => void;
  observe: (observer: SlideEventObserver) => void;
  unobserve: (observer: SlideEventObserver) => void;
}

export class SlideObservable implements ISlideObservable {
  slide: Slide;
  observers: SlideEventObserver[];

  constructor(slide: Slide) {
    this.slide = slide;
    this.observers = [];
  }

  notify(event: SlideEvent) {
    this.observers.forEach((observer, i) => observer(this.slide, event, i));
  }

  observe(observer: SlideEventObserver) {
    this.observers.push(observer);
  }

  unobserve(observer: SlideEventObserver) {
    const index = this.observers.findIndex((o) => observer === o);
    if (index !== -1) this.observers.splice(index, 1);
  }
}

export type SlideEventObserver = (
  slide: Slide,
  event: SlideEvent,
  index: number
) => void;

/* eslint-disable no-unused-vars */
export enum SlideEvent {
  animateInStarted = 1,
  animatedIn = 2,
  animateOutStarted = 3,
  animatedOut = 4,
}
/* eslint-enable no-unused-vars */

export interface IPage {
  state: PageState;
  users: IUser[];
}

/* eslint-disable no-unused-vars */
export enum PageState {
  offscreen = 1,
  scrollingin = 2,
  visible = 3,
  scrollingout = 4,
}
/* eslint-enable no-unused-vars */

export interface IUserData {
  title: string;
  value: number | string;
  metric?: SlideMetric;
}

export interface IUser {
  rank: number;
  icon: string;
  name: string;
  avgduration: string;
  allcalls: number;
  allanswered: number;
  allconnections: number;
  alldurationavg: number;
  alldurationsum: number;
  allincoming: number;
  allmissed: number;
  alloutgoing: number;
  incominganswered: number;
  incomingconnection: number;
  incomingmissed: number;
  outgoinganswered: number;
  outgoingconnection: number;
  outgoingmissed: number;
  tduration: number;
  data: IUserData[];
}

export interface ISlideComponentProps {
  slideObservable: SlideObservable;
  leaderboard: ILeaderboard;
}
